import API, { APIResponse } from '../../../lib/commons/api'

export type WbsItemGanttColorResponse = {
  uuid: string
  projectUuid: string
  wbsItemUuid: string
  color: string | null
  lockVersion: number
}

export type WbsItemGanttColorRequest = {
  edited: {
    wbsItemUuid: string
    color: string
  }[]
}

export const getWbsItemGanttColors = (): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_gantt_colors',
    undefined
  )

export const getCrossProjectWbsItemGanttColors = (
  projectUuids: string[]
): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_gantt_colors/cross_projects',
    { projectUuids }
  )

export const saveWbsItemGanttColors = (
  request: WbsItemGanttColorRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/wbs_item_gantt_colors/batch',
    request
  )
